import { Box, VStack } from "@chakra-ui/react";
import * as React from "react";

import { RichTextEditorContent } from "../../components/atoms";
import { Breadcrumb, Breadcrumbs } from "../../components/legacy";

interface PageProps {
  breadcrumbs: Breadcrumb[];
  headerImage: string | null;
  page: {
    content: any | null;
    title: string;
  };
}
const Page: React.FC<PageProps> = ({ breadcrumbs, headerImage, page }) => (
  <VStack paddingBottom="10">
    <div
      className="article-page__header"
      style={headerImage ? { backgroundImage: `url(${headerImage})` } : null}
    >
      <h1>{page.title}</h1>
    </div>
    <div className="container">
      <Box mb={4}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </Box>

      <div className="article-page__container">
        <div className="article-page__content">
          <RichTextEditorContent jsonData={page.content} />
        </div>
      </div>
    </div>
  </VStack>
);
export default Page;
